import React, { useEffect, useState, useContext } from 'react'
import moment from "moment";
import Utilities from '../../../services/commonservice/utilities'
import { store } from './../../../context/StateProvider'
import HPTSelect from './HPTSelect'
import DatePicker from "react-multi-date-picker"
import InputIcon from 'react-multi-date-picker/components/input_icon';
const HPTDatePicker = (props) => {
    const state = useContext(store).state
    const locationList = state.practiceLocations
    const [locationId, setLocationId] = useState(state.practiceLocationId || null)
    const [timePeriod, setTimePeriod] = useState(props.timePeriod || "day")

    const [month, setMonth] = useState(moment(props.startDate).month())
    const [year, setYear] = useState(moment(props.startDate).year())
    const [quarter, setQuarter] = useState(moment(props.startDate).quarter())

    const [startDate, setStartDate] = useState(props.startDate ? new Date(props.startDate) : new Date())
    const [endDate, setEndDate] = useState(props.endDate ? new Date(props.endDate) : new Date())
    const [dateRangeError, setDateRangeError] = useState('')

    const updateLocation = (newLocationId) => {
        setLocationId(newLocationId);
        props.setLocationId(newLocationId);
    }

    const validateDateRange = (startDateParam, endDateParam) => {
        if (timePeriod === 'custom' && startDateParam && endDateParam) {
            if (moment(endDateParam).isBefore(moment(startDateParam), 'day')) {
                // If end date is before start date, set end date to start date
                setDateRangeError('End date cannot be before start date. End date has been adjusted.');
                setEndDate(new Date(startDateParam));
                // Clear error after 3 seconds
                setTimeout(() => setDateRangeError(''), 3000);
                return false;
            } else {
                setDateRangeError('');
            }
        } else {
            setDateRangeError('');
        }
        return true;
    }

    const calculateAndSetDates = () => {

        //if (timePeriod !== "all" && !moment(startDate).isValid()) return; 
        let newStartDate = timePeriod === "all" ? null : moment(startDate).startOf("D");
        let newEndDate = timePeriod === "all" ? null : moment(endDate).endOf("D");

        // TODO needs to be the time zone of the practice!!!!!

        if (timePeriod === "all") { 
            setStartDate();
            setEndDate();
            return;
        }
        else if (timePeriod === "day"){
            newStartDate = moment(startDate).startOf("D")
            newEndDate = moment(startDate).endOf("D")
        }
        else if (timePeriod === "week"){
            // Week calculation is handled directly in DatePicker onChange
            // Skip calculation here to avoid overriding user selection
            return;
        }
        else if (timePeriod === "month"){
            // Month
            //     StartDate is the first of the month of the month and year selected
            //     EndDate is the last day of the month of the month and year selected
            let newDate = new Date(year, month, 1); 
            newStartDate = moment(newDate).startOf("M"); 
            newEndDate = moment(newDate).endOf('M').endOf("D");
        }
        else if (timePeriod === "quarter"){
            // Quarter
            //     StartDate is the first day of the first month of the quarter and year selected
            //     EndDate is the last day of the last month of the quarter and year selected
            let newMonth;
            if (quarter == 1) newMonth = 0;
            if (quarter == 2) newMonth = 3;
            if (quarter == 3) newMonth = 6;
            if (quarter == 4) newMonth = 9;
            let newDate = new Date(year, newMonth, 1); 
            newStartDate = moment(newDate).startOf("quarter");
            newEndDate = moment(newDate).endOf("quarter").endOf("M").endOf("D");
        }
        else if (timePeriod === "year"){
            // Year
            //     StartDate is January 1 of the year selected
            //     EndDate is December 31 of the year selected
            let newDate = new Date(year, 1, 1); 
            newStartDate = moment(newDate).startOf('year'); 
            newEndDate = moment(newDate).endOf('year').endOf("D");
        }
        else if (timePeriod === "custom") {
            // Custom
            //     StartDate is the start of the day for the selected start date
            //     EndDate is the end of the day for the selected end date
            if (startDate) {
                newStartDate = moment(startDate).startOf("D");
            }
            if (endDate) {
                newEndDate = moment(endDate).endOf("D");
            }
        }
        else {
            // need to check of display is different.  If it is use it instead
        }

        if (moment(newStartDate).isValid()) {
            //if (moment(newStartDate).diff(startDate, 'minutes') != 0) {
                setStartDate(newStartDate.toDate());
            //}
        }

        if (moment(newEndDate).isValid()) {
            //if (moment(newEndDate).diff(endDate, 'minutes') != 0) {
                const newEndDateObj = newEndDate.toDate();
                setEndDate(newEndDateObj);
                
                // Validate date range after setting both dates
                if (moment(newStartDate).isValid()) {
                    validateDateRange(newStartDate.toDate(), newEndDateObj);
                }
            //}
        }
    }

    useEffect(() => {
        if (startDate) {
            if (props.setStartDate) props.setStartDate(moment(startDate).startOf("D"))
            
            // Validate date range when start date changes
            if (timePeriod === 'custom') {
                validateDateRange(startDate, endDate);
            }
        }
        else {
            if (props.setStartDate) 
                props.setStartDate()
        }
    }, [startDate]) 

    useEffect(() => {
        if (endDate) {
            if (props.setEndDate) props.setEndDate(moment(endDate).endOf("D"))
        }
        else {
            if (props.setEndDate) 
                props.setEndDate()
        }
    }, [endDate]) 

    useEffect(() => {
        if (props.setTimePeriod) props.setTimePeriod(timePeriod)
    }, [timePeriod]) 

    useEffect(() => {
        calculateAndSetDates()
    }, [quarter,month,timePeriod])
    useEffect(() => {
        if (year<2015 || year>2055) return;
        calculateAndSetDates()
    }, [year])

    const changeTimePeriod = (newTimePeriod) => {

        if (props.setSlabBy) {
            switch (newTimePeriod) {
                case 'year':
                    props.setSlabBy("M")
                    break;
                case 'quarter':
                    props.setSlabBy("M")
                    break;
                case 'month':
                    props.setSlabBy("W")
                    break;
                case 'day':
                    props.setSlabBy("H")
                    break;
                case 'week':
                    props.setSlabBy("D")
                    break;
                default:
                    props.setSlabBy("D")
                    break;
            }
        }

        let newDate = Utilities.toDate(new Date())
        setStartDate(newDate)
        
        // For custom time period, also set endDate to current date
        if (newTimePeriod === "custom") {
            setEndDate(newDate)
        }
        // For week time period, calculate and set week range
        else if (newTimePeriod === "week") {
            const weekStart = moment(newDate).startOf('W').toDate();
            const weekEnd = moment(newDate).endOf('W').endOf('D').toDate();
            setStartDate(weekStart);
            setEndDate(weekEnd);
        }

        if (newTimePeriod === "month"){
            let newMonth = moment(newDate).month(); 
            setMonth(newMonth); 
        }
        else if (newTimePeriod === "quarter"){
            let newQuarter = moment(newDate).quarter(); 
            setQuarter(newQuarter); 
        }
        else if (newTimePeriod === "year"){
            let newYear = moment(newDate).year();
            setYear(newYear); 
        }

        setTimePeriod(newTimePeriod)

    }

    return (
        <>
            <div className='col-md-auto col-12' style={{ minWidth: '150px' }}>
                <div className='ui field'>
                    <label>Time Period</label>
                    <HPTSelect
                        className="react-select-container"
                        classNamePrefix="react-select"
                        placeholder="Select Time Period"
                        value={{ value: timePeriod, label: timePeriod.charAt(0).toUpperCase() + timePeriod.slice(1) }}
                        onChange={e => changeTimePeriod(e.value)}
                        options={[
                            { value: 'day', label: 'Day' },
                            { value: 'week', label: 'Week' },
                            { value: 'month', label: 'Month' },
                            { value: 'quarter', label: 'Quarter' },
                            { value: 'year', label: 'Year' },
                            { value: 'custom', label: 'Custom' },
                            ...(props.includeAll ? [{ value: 'all', label: 'All' }] : [])
                        ]}
                        isSearchable
                        isClearable={false}
                        getOptionLabel={(option) => option.label}
                        getOptionValue={(option) => option.value}
                    />
                </div>
            </div>
            {timePeriod === 'quarter' || timePeriod === 'year' || timePeriod === 'month' ? <div className='col-md-auto col-12'>
                <div className='ui field'>
                    <label>Year</label>
                    <input type="number" value={year} onChange={e => { e.preventDefault(); setYear(e.target.value); }} />
                </div>
            </div> : null}
            {timePeriod === 'quarter' && <div className='col-md-auto col-12'>
                <div className='ui field'>
                    <label>Quarter</label>
                    <HPTSelect
                        className="react-select-container"
                        classNamePrefix="react-select"
                        placeholder="Select Quarter"
                        value={{ value: quarter, label: `Q${quarter}` }}
                        onChange={e => setQuarter(parseInt(e.value))}
                        options={[
                            { value: 1, label: 'Q1' },
                            { value: 2, label: 'Q2' },
                            { value: 3, label: 'Q3' },
                            { value: 4, label: 'Q4' }
                        ]}
                        isSearchable
                        isClearable={false}
                        getOptionLabel={(option) => option.label}
                        getOptionValue={(option) => option.value}
                    />
                </div>
            </div>}
            {timePeriod === 'month' && <div className='col-md-auto col-12'>
                <div className='ui field'>
                    <label>Month</label>
                    <HPTSelect
                        className="react-select-container"
                        classNamePrefix="react-select"
                        placeholder="Select Month"
                        value={{ value: month, label: moment().month(month).format('MMMM') }}
                        onChange={e => setMonth(parseInt(e.value))}
                        options={Array.from({ length: 12 }, (_, i) => ({
                            value: i,
                            label: moment().month(i).format('MMMM')
                        }))}
                        isSearchable
                        isClearable={false}
                        getOptionLabel={(option) => option.label}
                        getOptionValue={(option) => option.value}
                    />
                </div>
            </div>}
            {timePeriod === 'week' || timePeriod === 'day' || timePeriod === 'custom' ? <div className='col-md-auto col-12' style={{ minWidth: timePeriod === 'week' ? '280px' : '200px' }}>
                <div className='ui field'>
                    <label>{timePeriod === 'week' ? 'Week Range' : 'Start Date'}</label>
                    <DatePicker
                        key={`startDate-${timePeriod}`}
                        name="startDate"
                        value={timePeriod === 'week' && startDate && endDate ? 
                            [new Date(startDate), new Date(endDate)] : 
                            (startDate ? new Date(startDate) : null)
                        }
                        range={timePeriod === 'week'}
                        rangeHover={timePeriod === 'week'}
                        dateSeparator=" to "
                        format={"MM-DD-YYYY"}
                        placeholder={timePeriod === 'week' ? "Select week range" : "Select date"}
                        style={{
                            width: timePeriod === 'week' ? '250px' : '200px',
                            display: 'block'
                        }}
                        containerStyle={{
                            display: 'block',
                            width: '100%'
                        }}
                        onChange={(date) => {
                            if (date) {
                                if (timePeriod === 'week') {
                                    // For week selection, handle both array and single date
                                    let selectedDate;
                                    if (Array.isArray(date)) {
                                        selectedDate = date.length > 0 ? new Date(date[0]) : null;
                                    } else {
                                        selectedDate = new Date(date);
                                    }
                                    
                                    if (selectedDate) {
                                        // Calculate week start and end dates immediately
                                        const weekStart = moment(selectedDate).startOf('W').toDate();
                                        const weekEnd = moment(selectedDate).endOf('W').endOf('D').toDate();
                                        setStartDate(weekStart);
                                        setEndDate(weekEnd);
                                    }
                                } else {
                                    // For day and custom single date selection
                                    const newStartDate = new Date(date);
                                    setStartDate(newStartDate);
                                    
                                    // If end date is before the new start date, update end date to match start date
                                    if (timePeriod === 'custom' && endDate && moment(endDate).isBefore(moment(newStartDate), 'day')) {
                                        setEndDate(newStartDate);
                                    }
                                }
                            }
                        }}
                        disabled={timePeriod !== 'day' && timePeriod !== 'week' && timePeriod !== 'custom'}
                        render={<InputIcon/>}
                    />
                </div>
            </div> : null}
            {timePeriod === 'custom' && <div className='col-md-auto col-12'>
                <div className='ui field'>
                    <label>End Date</label>
                    <DatePicker
                        key={`endDate-${timePeriod}`}
                        name="endDate"
                        value={endDate ? new Date(endDate) : null}
                        format={"MM-DD-YYYY"}
                        minDate={startDate ? new Date(startDate) : null}
                        onChange={(date) => {
                            if (date) {
                                const newEndDate = new Date(date);
                                // Validate that end date is not before start date
                                if (startDate && moment(newEndDate).isBefore(moment(startDate), 'day')) {
                                    // If user tries to select end date before start date, set it to start date
                                    setDateRangeError('End date cannot be before start date. Date has been adjusted to start date.');
                                    setEndDate(new Date(startDate));
                                    // Clear error after 3 seconds
                                    setTimeout(() => setDateRangeError(''), 3000);
                                } else {
                                    setDateRangeError('');
                                    setEndDate(newEndDate);
                                }
                            }
                        }}
                        disabled={timePeriod !== 'custom'}
                        render={<InputIcon/>}
                    />
                </div>
            </div>}

            {dateRangeError && (
                <div className='col-12'>
                    <div className='ui error message' style={{ display: 'block', marginTop: '10px' }}>
                        <i className="exclamation triangle icon"></i>
                        {dateRangeError}
                    </div>
                </div>
            )}

            {props.setLocationId ?
            <div className='col-md-auto col-12' style={{ minWidth: '250px' }}>
                <div className='ui field'>
                    <label>Practice Location</label>
                    <HPTSelect
                    className="react-select-container"
                    classNamePrefix="react-select"
                    options={locationList && locationList}
                    isLoading={!locationList}
                    isDisabled={!locationList}
                    isClearable={props.locationClearable?props.locationClearable:false}
                    loadingMessage="loading..."
                    name="practiceLocationId"
                    value={locationList && Array.isArray(locationList) ? locationList.find(obj => obj.practiceLocationId === locationId) : null}
                    onChange={e => {
                        if (e?.practiceLocationId) {
                            updateLocation(e.practiceLocationId)
                        }
                        else {
                            updateLocation()
                        }
                    }}
                    placeholder={props.practicePlaceHolder || 'All Locations'}
                    getOptionLabel={(option) => option.practiceLocation}
                    getOptionValue={(option) => option.practiceLocationId}
                    >
                    </HPTSelect>
                </div>                
            </div> : null}
        </>
    )
}
export default HPTDatePicker